const CLASSNAME = 'form';
const passwordRegex = '^$|^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\\s).{8,}$';
const emailRegex = '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$';
const phoneRegex = '^$|^\\+?[0-9\\s\\-()]{7,20}$';

const FORM_SCHEMA = ({ privacyPolicyUrl, emailUpdatesInfo }) => {
  const privacyUrl = privacyPolicyUrl ?? '/privacy-policy';
  return {
    type: 'object',
    properties: {
      // --- Your Login
      email: {
        fieldId: 'email',
        label: 'Your email',
        showInForm: true,
        formFieldType: 'email',
        placeholder: '',
        type: 'string',
        pattern: emailRegex,
        errorMessage: `Please enter a valid email address`,
        isRequired: true,
        section: 0
      },
      password: {
        fieldId: 'password',
        label: 'Password',
        showInForm: true,
        formFieldType: 'password',
        placeholder: '',
        type: 'string',
        pattern: passwordRegex,
        isRequired: true,
        errorMessage:
          'Must contain 8 or more characters with a mix of upper & lower case letters, numbers & symbols',
        section: 0,
        group: 'password'
      },
      passwordConfirm: {
        fieldId: 'passwordConfirm',
        label: 'Confirm password',
        showInForm: true,
        formFieldType: 'password',
        placeholder: '',
        type: 'string',
        isRequired: true,
        group: 'password',
        section: 0
      },

      // --- Your details
      firstname: {
        fieldId: 'firstname',
        label: 'First name',
        showInForm: true,
        formFieldType: 'text',
        placeholder: '',
        type: 'string',
        minLength: 1,
        errorMessage: 'Please fill this in',
        isRequired: true,
        section: 1,
        group: 'name'
      },
      lastname: {
        fieldId: 'lastname',
        label: 'Last name',
        showInForm: true,
        formFieldType: 'text',
        placeholder: '',
        type: 'string',
        minLength: 1,
        errorMessage: 'Please fill this in',
        isRequired: true,
        section: 1,
        group: 'name'
      },
      jobTitle: {
        fieldId: 'jobTitle',

        label: 'Job title',
        showInForm: true,
        formFieldType: 'text',
        placeholder: '',
        type: 'string',
        minLength: 1,
        errorMessage: 'Please fill this in',
        isRequired: true,
        section: 1,
        group: 'occupation'
      },
      organisation: {
        fieldId: 'organisation',
        label: 'Organisation',
        showInForm: true,
        formFieldType: 'text',
        placeholder: '',
        type: 'string',
        minLength: 1,
        errorMessage: 'Please fill this in',
        isRequired: true,
        section: 1,
        group: 'occupation'
      },

      telephoneNumber: {
        fieldId: 'telephoneNumber',
        label: 'Telephone',
        showInForm: true,
        formFieldType: 'tel',
        placeholder: '',
        type: 'string',
        pattern: phoneRegex,
        errorMessage: `Please enter a valid telephone number`,
        isRequired: true,
        minLength: 1,
        section: 1,
        group: 'phone'
      },
      mobileNumber: {
        fieldId: 'mobileNumber',
        label: 'Mobile',
        showInForm: true,
        formFieldType: 'tel',
        placeholder: '',
        type: 'string',
        pattern: phoneRegex,
        errorMessage: `Please enter a valid mobile number`,
        isRequired: false,
        section: 1,
        group: 'phone'
      },

      // -- Address
      line1: {
        fieldId: 'line1',
        label: 'Address 1',
        showInForm: true,
        formFieldType: 'text',
        placeholder: '',
        type: 'string',
        minLength: 1,
        errorMessage: 'Please fill this in',
        isRequired: true,
        section: 2
      },
      line2: {
        fieldId: 'line2',
        label: 'Address 2',
        showInForm: true,
        formFieldType: 'text',
        placeholder: '',
        type: 'string',
        minLength: 0,
        isRequired: false,
        section: 2
      },
      city: {
        fieldId: 'city',
        label: 'Town / City',
        showInForm: true,
        formFieldType: 'text',
        placeholder: '',
        type: 'string',
        minLength: 1,
        errorMessage: 'Please fill this in',
        isRequired: true,
        section: 2,
        group: 'address a'
      },
      country: {
        fieldId: 'country',
        label: 'Country',
        showInForm: true,
        formFieldType: 'select',
        isRequired: true,
        placeholder: 'Please choose...',
        type: 'string',
        minLength: 1,
        errorMessage: 'Please fill this in',
        options: [],
        section: 2,
        group: 'address b'
      },
      county: {
        fieldId: 'county',
        label: 'County / State',
        showInForm: true,
        formFieldType: 'select',
        isRequired: false,
        placeholder: 'Please choose...',
        type: 'string',
        errorMessage: 'Please fill this in',
        options: [],
        section: 2,
        group: 'address b'
      },
      zip: {
        fieldId: 'zip',
        label: 'Post code / Zip code',
        showInForm: true,
        formFieldType: 'text',
        placeholder: '',
        type: 'string',
        minLength: 1,
        errorMessage: 'Please fill this in',
        isRequired: true,
        section: 2,
        group: 'address b'
      },
      dataProtection: {
        fieldId: 'dataProtect',
        info: true,
        text: `Newton Media Group shall not pass on your data to third parties. You can read the privacy policy <a href="${privacyUrl}" target="_blank" rel="noopener noreferrer">here</a>.`,
        showInForm: true,
        section: 3
      },
      emailUpdatesInfo: {
        fieldId: 'euInfo',
        info: true,
        text: `${emailUpdatesInfo}`,
        showInForm: true,
        section: 4
      },
      emailPermission: {
        fieldId: 'emailPermission',
        type: 'boolean',
        value: false,
        label: "Please don't send me the email newsletter",
        formFieldType: 'checkbox',
        showInForm: true,
        section: 4
      }
    },
    allOf: [
      {
        if: {
          properties: {
            password: { type: 'string' },
            passwordConfirm: { type: 'string' }
          },
          required: ['password', 'passwordConfirm']
        },
        then: {
          properties: {
            passwordConfirm: {
              const: { $data: '1/password' },
              errorMessage: {
                const: 'Password does not match'
              }
            }
          }
        }
      }
    ],

    required: [
      'email',
      'password',
      'passwordConfirm',
      'firstname',
      'lastname',
      'jobTitle',
      'organisation',
      'telephoneNumber',
      'country',
      'line1',
      'city',
      'zip'
    ],
    sections: [
      'Your login details',
      'Your personal details',
      'Address',
      'Data Protection',
      'Email updates'
    ]
  };
};

export { CLASSNAME, FORM_SCHEMA };
